/**
 * 🤖 AUTO-GENERATED API SCHEMA FILE - DO NOT EDIT DIRECTLY!
 *
 * This file is automatically generated from entity configuration files.
 * Any manual changes will be lost when the generator runs again.
 *
 * 🔄 DATA FLOW PIPELINE:
 * 1. Entity Config (config/entities/lookup_building_classes-entity-config.ts) → Single Source of Truth
 * 2. THIS FILE → TypeBox schemas for runtime validation + API types
 * 3. API Clients → Use these schemas for request/response validation
 * 4. React Hooks → Use these types for type-safe data fetching
 * 5. Components → Import types from this schema file
 *
 * 🛠️ TO MODIFY:
 * - Edit the entity config file: config/entities/lookup_building_classes-entity-config.ts
 * - Run: npm run schemas:gen (regenerates this file)
 *
 * 📋 ARCHITECTURE:
 * - Entity configs define field publicity, types, and validation rules
 * - TypeBox schemas provide runtime validation for API requests/responses
 * - Static types are derived from TypeBox schemas for compile-time safety
 * - Query options and response types standardize API interactions
 *
 * 🔗 RELATED FILES:
 * - config/entities/lookup_building_classes-entity-config.ts (source configuration)
 * - scripts/generate-api-clients.ts (this generator)
 * - client/api/generated_clients/generated-lookup_building_classes-api-client.ts (API client using these schemas)
 * - client/api/generated_hooks/lookup_building_classes.ts (React hooks using these types)
 *
 * 🔒 SECURITY: Only fields marked as 'public: true' in the config are included
 *
 * Source config: config/entities/lookup_building_classes-entity-config.ts
 * Public fields: 8/8 total fields
 */

import { Type, Static } from '@sinclair/typebox';


// TypeBox schemas for runtime validation (public fields only)
export const LookupBuildingClassesSchema = Type.Object({
  id: Type.String({ format: "uuid" }), // id field
  name: Type.Union([Type.String(), Type.Null()]), // name field
  code: Type.Union([Type.String(), Type.Null()]), // code field
  description: Type.Union([Type.String(), Type.Null()]), // description field
  created_at: Type.Union([Type.String({ format: "date-time" }), Type.Null()]), // created_at field
  archived: Type.Boolean(), // archived field
  sort_order: Type.Number(), // sort_order field
  updated_at: Type.String({ format: "date-time" }), // updated_at field
});

export const CreateLookupBuildingClassesSchema = Type.Object({
  name: Type.Optional(Type.Union([Type.String(), Type.Null()])), // name field
  code: Type.Optional(Type.Union([Type.String(), Type.Null()])), // code field
  description: Type.Optional(Type.Union([Type.String(), Type.Null()])), // description field
  archived: Type.Optional(Type.Boolean()), // archived field
  sort_order: Type.Optional(Type.Number()), // sort_order field
});

export const UpdateLookupBuildingClassesSchema = Type.Object({
  name: Type.Optional(Type.Union([Type.String(), Type.Null()])), // name field
  code: Type.Optional(Type.Union([Type.String(), Type.Null()])), // code field
  description: Type.Optional(Type.Union([Type.String(), Type.Null()])), // description field
  archived: Type.Optional(Type.Boolean()), // archived field
  sort_order: Type.Optional(Type.Number()), // sort_order field
});

// TypeScript types derived from TypeBox schemas (matching server-side pattern)
export type LookupBuildingClassesRow = Static<typeof LookupBuildingClassesSchema>;
export type LookupBuildingClassesInsert = Static<typeof CreateLookupBuildingClassesSchema>;
export type LookupBuildingClassesUpdate = Static<typeof UpdateLookupBuildingClassesSchema>;

// Legacy type aliases for backward compatibility
export type LookupBuildingClasses = LookupBuildingClassesRow;
export type CreateLookupBuildingClasses = LookupBuildingClassesInsert;
export type UpdateLookupBuildingClasses = Static<typeof UpdateLookupBuildingClassesSchema>;

// Field configuration metadata
export const LookupBuildingClassesFieldConfig = {
  filterable: ['id'] as const,
  sortable: ['created_at', 'updated_at'] as const,
  searchable: [] as const,
  required: ['id', 'archived', 'sort_order', 'updated_at'] as const,
  readonly: ['id', 'created_at', 'updated_at'] as const,
} as const;

// Query options interface for API operations
import type { UnifiedQueryOptions } from '../../config/search/global-search-config.js';

export interface LookupBuildingClassesQueryOptions extends UnifiedQueryOptions {}

// Response types for API operations
export interface LookupBuildingClassesResponse {
  data: LookupBuildingClasses[] | null;
  error: Error | null;
  count?: number;
}

export interface SingleLookupBuildingClassesResponse {
  data: LookupBuildingClasses | null;
  error: Error | null;
}
